// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.mediacredits.RentalManagerMediaCreditsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { CustomerAnalyticsMediaCreditPackageDto } from '../..';

export const RentalManagerMediaCreditsWebApiHandler_getMediaCredits_Path =
  '/api/web/v2/users/properties/mediaCredits/getMediaCredits';

/**
 * Get media credit packages for the logged-in user's account
 */
export const RentalManagerMediaCreditsWebApiHandler_getMediaCredits = (client = getClient()) => {
  return httpFrontEndRequest<never, never, CustomerAnalyticsMediaCreditPackageDto>(
    {
      endpoint: RentalManagerMediaCreditsWebApiHandler_getMediaCredits_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
